/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add names to pick who goes first.`)
};

const es_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade nombres para elegir quién va primero.`)
};

const de_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge Namen hinzu, um zu bestimmen, wer beginnt.`)
};

const nl_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg namen toe om te kiezen wie er als eerste mag.`)
};

const fr_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez des noms pour tirer qui commence.`)
};

const it_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi dei nomi per scegliere chi va per primo.`)
};

const pt_br2_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione nomes para sortear quem vai primeiro.`)
};

const pt_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione nomes para escolher quem vai primeiro.`)
};

const ja_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を追加して、誰が最初にやるかを選びましょう。`)
};

const zh_dw_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加姓名，抽取谁先开始。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_ex2", locale)
	if (locale === "en") return en_dw_ex2(inputs)
	if (locale === "es") return es_dw_ex2(inputs)
	if (locale === "de") return de_dw_ex2(inputs)
	if (locale === "nl") return nl_dw_ex2(inputs)
	if (locale === "fr") return fr_dw_ex2(inputs)
	if (locale === "it") return it_dw_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_dw_ex2(inputs)
	if (locale === "pt") return pt_dw_ex2(inputs)
	if (locale === "ja") return ja_dw_ex2(inputs)
	return zh_dw_ex2(inputs)
};